import { inject, Injectable } from "@angular/core";
import { ApiWrapperService } from "ngx-apiwrapper";

@Injectable({
    providedIn: 'root'
})
export class MiscDataService {
    private readonly _apiWrapper = inject(ApiWrapperService);
    
    checkConnectionStatus(){
        return this._apiWrapper.get<boolean>('checkconnectionstatus');
    }
}